import { Fragment } from 'react';

interface AllianceProgressTimelineProps {
  status: string;
}

const STEPS = [
  { value: 'applied', label: '応募' },
  { value: 'document_screening', label: '書類選考' },
  { value: 'in_progress', label: '選考中' },
  { value: 'offered', label: '内定' },
  { value: 'accepted', label: '承諾' },
] as const;

const NEGATIVE_LABELS: Record<string, string> = {
  candidate_declined: '候補者辞退',
  rejected: '不採用',
};

export default function AllianceProgressTimeline({ status }: AllianceProgressTimelineProps) {
  const negativeLabel = NEGATIVE_LABELS[status];
  const currentIndex = negativeLabel ? -1 : STEPS.findIndex((step) => step.value === status);

  return (
    <div className="flex flex-col items-end gap-xs">
      <div className="flex w-[520px] items-start">
        {STEPS.map((step, index) => {
          const isDone = currentIndex > index;
          const isCurrent = currentIndex === index;
          return (
            <Fragment key={step.value}>
              <div className="flex w-14 shrink-0 flex-col items-center gap-xxs">
                <div className="flex h-4 items-center justify-center">
                  {isCurrent ? (
                    <span className="size-4 rounded-full bg-primary" />
                  ) : (
                    <span
                      className={`size-[11px] rounded-full ${isDone ? 'bg-primary' : 'bg-disabled'}`}
                    />
                  )}
                </div>
                <span
                  className={`text-center text-body-xs font-bold ${
                    isCurrent ? 'text-main' : 'text-placeholder'
                  }`}
                >
                  {step.label}
                </span>
              </div>
              {index < STEPS.length - 1 && (
                <div
                  className={`mt-[7px] h-0 flex-1 border-t-2 ${
                    isDone ? 'border-solid border-primary' : 'border-dashed border-disabled'
                  }`}
                />
              )}
            </Fragment>
          );
        })}
      </div>
      {negativeLabel && (
        <span className="rounded-full border border-solid border-danger px-sm py-xxs text-body-xs text-danger">
          {negativeLabel}
        </span>
      )}
    </div>
  );
}
